export const preiseFAQData = [
  {
    question: "Wie viel kostet ein Finanzcoaching?",
    answer: "Finanzcoaching wird honorarbasiert abgerechnet. Flex-Zeit kostet 145€ pro Stunde brutto. Weitere Paketoptionen werden im Erstgespräch besprochen."
  },
  {
    question: "Was kostet Executive Coaching für Führungskräfte?",
    answer: "Executive Coaching kostet ab 200€ pro Stunde netto. Für längerfristige Begleitungen biete ich attraktive Paketkonditionen an, die wir individuell vereinbaren."
  },
  {
    question: "Werden Paketpreise individuell vereinbart?",
    answer: "Ja, Paketpreise werden individuell je nach Art und Umfang der Dienstleistung vereinbart. So erhalten Sie eine maßgeschneiderte Lösung für Ihre Bedürfnisse."
  },
  {
    question: "Ist das Erstgespräch kostenfrei?",
    answer: "Ja, das 30-minütige Erstgespräch ist kostenfrei und unverbindlich. Wir lernen uns kennen, klären Ihre Ziele und besprechen das passende Coaching-Format."
  },
  {
    question: "Wie werden die Zahlungskonditionen vereinbart?",
    answer: "Zahlungsweisen werden immer vertraglich vereinbart. Bei Paketen und Neukunden nehme ich gerne Teilbeträge oder Vorauszahlungen pro Sitzung entgegen. Dies schafft Sicherheit für beide Seiten und ermöglicht eine vertrauensvolle Zusammenarbeit."
  },
  {
    question: "Was kostet ein Finanzcoach?",
    answer: "Die Investition richtet sich nach Umfang und Status. Details auf der <a href='/preise'>Preisseite</a>. Im kostenfreien Erstgespräch klären wir gemeinsam, welches Format zu Ihnen passt."
  }
];